import { Controller } from 'stimulus'

export default class extends Controller {
  connect () {
    const hash = this.element.closest('form').id
    document.location.hash = hash
  }
}
